export const notification = {
    aria: {
        closeButtonLabel: 'close notification',
    },
};
//# sourceMappingURL=notification.js.map